module.exports = __webpack_public_path__ + "images/emails/signatures/sara-357071d029664d842c72643550b20d27.jpg";